<template>
  <div class="group">
    <md-button
      v-if="isNew"
      @click="showDialog = true"
      class="md-accent md-raised"
      >+ Add Group</md-button
    >
    <md-button v-else @click="showDialog = true" class="md-icon-button"
      ><md-icon>edit</md-icon></md-button
    >
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title
        ><span v-if="isNew">Create</span
        ><span v-else>Edit</span> Group</md-dialog-title
      >
      <md-dialog-content>
        <div class="md-layout">
          <div class="md-layout-item p10">
            <md-field :class="messageClassLabel">
              <label>Group Name</label>
              <md-input v-model="label" required></md-input>
              <span class="md-error">{{
                nameError
                  ? " This Group Name already exists."
                  : "Please fill Group Name"
              }}</span>
            </md-field>
          </div>
          <div class="md-layout-item p10">
            <md-field class="md-field-select">
              <label>Status</label>
              <md-select class="status" v-model="status">
                <md-option
                  :key="key"
                  v-for="(status, key) in statuses"
                  :value="status"
                  >{{ key | capitalize }}</md-option
                >
              </md-select>
            </md-field>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="onCancel">Close</md-button>
        <md-button class="md-accent md-raised" @click="onSave">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import GroupStatuses from "../helpers/GroupStatuses";

export default {
  name: "GroupEdit",
  props: ["group", "show", "isNew"],
  computed: {
    messageClassLabel() {
      return {
        "md-invalid":
          this.validate && (!this.label || this.label == "" || this.nameError),
      };
    },
    isValid() {
      return this.label.length;
    },
  },
  data() {
    return {
      statuses: GroupStatuses.getStatuses(),
      showDialog: false,
      label: this.group && this.group.label ? this.group.label : "",
      status:
        !this.isNew && this.group && this.group.status ? this.group.status : 1,
      validate: false,
      nameError: false,
    };
  },
  methods: {
    async onSave() {
      this.validate = true;
      if (!this.isValid) {
        return;
      }
      this.validate = false;
      if (this.isNew) {
        await this.$apollo
          .mutate({
            mutation: require("../graphql/CreateGroup.gql"),
            variables: {
              label: this.label,
              status: parseInt(this.status),
            },
          })
          .then(() => {
            this.nameError = false;
          })
          .catch(() => {
            this.validate = true;
            this.nameError = true;
          });
        if (this.nameError) {
          return;
        }
        this.label = "";
        this.status = 1;
      } else {
        await this.$apollo.mutate({
          mutation: require("../graphql/UpdateGroup.gql"),
          variables: {
            id: this.group.id,
            status: parseInt(this.status),
            label: this.label,
          },
        });
      }
      this.$emit("updateQuery");
      this.showDialog = false;
    },
    onCancel() {
      this.label = this.group ? this.group.label : "";
      this.status = this.group ? this.group.status : 1;
      this.showDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.group {
  display: inline-block;
}
</style>